/**
 * Ensures an image URL has an https:// protocol prefix.
 * Returns null if the URL is empty.
 */
export const normalizeImageUrl = (url) => {
  if (!url?.length) return null
  return /^https?:\/\//i.test(url) ? url : `https://${url}`
}

